import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Text,
  Link,
  VStack,
} from '@chakra-ui/react';
import { externalLinks } from 'app/api.config';
import { AuddlySignUpFormStep } from 'types/enums';
import { TEST_ID_LOADING_INDICATOR } from 'app/utils/test/constants';
import { ResendCode } from 'app/components/ResendCode';
import { linkStyle } from 'app/components/AuddlySignUp/utils';

interface AuddlySignUpActionsProps {
  isSubmitting?: boolean;
  submitEnabled: boolean;
  step: AuddlySignUpFormStep;
  onNext: () => void;
  disableNextStep: boolean;
  email: string;
  resendLink?: string;
}

export const AuddlySignUpActions: React.FC<AuddlySignUpActionsProps> = ({
  isSubmitting = false,
  submitEnabled,
  step,
  onNext,
  disableNextStep,
  email,
  resendLink,
}) => (
  <VStack position="relative" my={6} mx="auto">
    {isSubmitting && (
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        data-testid={TEST_ID_LOADING_INDICATOR}
      >
        <CircularProgress
          isIndeterminate
          color="black"
          size="40px"
          thickness="7px"
        />
      </Box>
    )}

    {step === AuddlySignUpFormStep.PASSWORD_CREATION && (
      <>
        <Button
          width="full"
          isDisabled={disableNextStep}
          onClick={onNext}
          data-testid="next-step-btn"
        >
          Next
        </Button>
        <ResendCode pt={4} email={email} link={resendLink} />
      </>
    )}
    {step === AuddlySignUpFormStep.LOCATION_DETAILS && (
      <>
        <Button
          type="submit"
          width="full"
          isDisabled={!submitEnabled || isSubmitting}
          my={1}
          mx={0}
        >
          Create Account
        </Button>
        <Box pt={4}>
          <Text fontSize="sm" lineHeight="24px" letterSpacing="0.15px">
            By continuing you agree to Session&apos;s <br />
            <Link
              href={externalLinks.signUp.TERMS_AND_CONDITIONS}
              {...linkStyle}
              target="_blank"
            >
              Terms &amp; Conditions
            </Link>
            &nbsp; and
            <Link
              href={externalLinks.signUp.PRIVACY_POLICY}
              {...linkStyle}
              target="_blank"
            >
              Privacy Policy
            </Link>
          </Text>
        </Box>
      </>
    )}
  </VStack>
);
